<!-- ================:=========================================================================
  File Name: EditCourse.vue
  Description: User Edit Page

========================================================================================== -->

<template>
  <div id="course-new">
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Details" icon-pack="feather" icon="icon-edit">
            <div class="tab-text">
              <lab-details-tab :data="labData" v-on:update_labData="labDataUpdate" v-on:insert_labData="createAccount" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import LabDetailsTab from './AccountDetailsTab.vue';
import axios from 'axios';

export default {
  components: {
    LabDetailsTab,
  },
  data() {
    return {
      labData: {
        pool: undefined,
        username: undefined,
        password: undefined,
      },

      activeTab: 0,
    };
  },
  watch: {
    activeTab() {
      //tab change
    },
  },
  methods: {
    labDataUpdate(data) {
      this.labData = data;
    },
    createAccount() {
      this.$vs.loading();

      this.$httpLabs
        .post('labs/accounts', this.labData)
        .then((response) => {
          this.$vs.loading.close();

          this.$vs.notify({
            title: 'Created account successfully',
            text: 'New account has been created.',
            color: 'success',
            position: 'top-right',
          });

          if (response.status === 200) {
            const data = response.data;
            this.$router.push(`/a/labs/accounts/${data.id}`);
          }
        })
        .catch((exception) => {
          this.$vs.loading.close();

          let error = 'An unknown error occurred while creating this account';
          if (exception.response) {
            error = exception.response.data.message;
          }

          return this.$vs.notify({
            title: 'Failed to create account',
            text: error,
            color: 'danger',
            position: 'top-right',
          });
        });
    },
  },
};
</script>
